import type { GQL_ID } from '@@partner:types:graphql'
import type { DeliverySlot, RsuiteSortType } from '@@partner:types:app'

import React from 'react'

import AppLoader from '@components/common/AppLoader'
import { Button, Table } from 'rsuite'
import { formatDate, formatDayMonthYear } from '@@partner:helpers/util'
import { generatePath, Link } from 'react-router-dom'
import { ROUTE_SHOPS_EDIT_SLOT } from '@@partner:config/routes'
import { sortOrderDirectionToSortType } from '@@partner:helpers/data-mappers/sort'

export interface SlotsTableProps {
  brandSlug: string
  slots: DeliverySlot[]
  shopId: GQL_ID
  loading?: boolean
  onSortClick: (sortColumn: string, sortType?: RsuiteSortType) => void
  sort: {
    fieldName: string
    direction: number
  }
}

const { Column, HeaderCell, Cell } = Table

export default function ShopSlotsTable ({
  brandSlug,
  slots,
  shopId,
  loading,
  onSortClick,
  sort
}: SlotsTableProps) {
  const sortType = sortOrderDirectionToSortType(sort.direction)

  return (
    <Table
      data={slots}
      autoHeight
      wordWrap
      loading={loading}
      renderLoading={() =>
        loading ? <AppLoader.Inner content="Загрузка таблицы" /> : null
      }
      onSortColumn={onSortClick}
      sortColumn={sort.fieldName}
      sortType={sortType}
      rowHeight={80}
      affixHeader
    >
      <Column flexGrow={1} verticalAlign="middle" sortable>
        <HeaderCell>ID</HeaderCell>
        <Cell dataKey="id" />
      </Column>
      <Column flexGrow={1} verticalAlign="middle" sortable>
        <HeaderCell>Дата</HeaderCell>
        <Cell dataKey="ts_start">
          {(slot: DeliverySlot) => (
            <div>
              {formatDayMonthYear(new Date(parseInt(slot.period.from)))}
            </div>
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>Время</HeaderCell>
        <Cell dataKey="slotTime" />
      </Column>
      <Column flexGrow={2} verticalAlign="middle" sortable>
        <HeaderCell>Доступен до</HeaderCell>
        <Cell dataKey="timeout">
          {(slot: DeliverySlot) => (
            <div>{formatDate(new Date(parseInt(slot.availableUntil)))}</div>
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>Лимиты</HeaderCell>
        <Cell>
          {(slot: DeliverySlot) => (
            <>
              <div>{slot.orders_capacity} заказов</div>
              <div>{slot.position_capacity} позиций</div>
            </>
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>Статистика</HeaderCell>
        <Cell>
          {(slot: DeliverySlot) => (
            <>
              <div>{slot.orders_count} заказов</div>
              <div>{slot.positions_count} позиций</div>
            </>
          )}
        </Cell>
      </Column>
      <Column flexGrow={2} fixed="right" verticalAlign="middle">
        <HeaderCell>Управление</HeaderCell>
        <Cell>
          {(slot: DeliverySlot) => (
            <>
              <Button
                color="cyan"
                as={Link}
                to={generatePath(ROUTE_SHOPS_EDIT_SLOT, {
                  brandSlug,
                  shopId: shopId,
                  slotId: slot.id
                })}
                size="xs"
              >
                Изменить
              </Button>
            </>
          )}
        </Cell>
      </Column>
    </Table>
  )
}
